module.exports = __webpack_public_path__ + "static/media/possible-loss-of-income.ae0aeee9.svg";